import { IComponent, getV2ValueWP, tryParseJSON } from "@eventr/common";
import { useCallback } from "react";
import _ from "underscore";
import { useMatchTagsAndUsers } from "v2/componentCards/hooks/useMatchTagsAndUsers";
import { ComponentFinder } from "../componentFinder";
interface IArrayFinderProps {
  data: any;
  renderOptions: IArrayFinderOptions;
  past?: boolean;
}
interface IExpression {
  operator: "===" | "!==" | ">" | "<" | ">=" | "<=" | "userIn" | "filter ===";
  param1: string;
  param2: string;
}
interface IArrayFinderOptions {
  components: IComponent[];
  value: string;
  parentValue?: string;
  expression: IExpression;
  fieldNonEmpty?: string;
}
export const ArrayFinder = ({ data, renderOptions, past }: IArrayFinderProps) => {
  const { matchTagsAndUser, subjectUser } = useMatchTagsAndUsers();

  const value = useCallback(() => {
    const array = data[renderOptions.value];
    if (array) {
      if (renderOptions.expression) {
        const { operator, param1, param2 } = renderOptions.expression;
        const parentValues: string[] = (renderOptions.parentValue || "").split("&123&") || [];
        switch (operator) {
          case "===":
            return array.find((v: any) => {
              if (renderOptions.parentValue) {
                let userArray: any[] = [];
                parentValues.forEach((val) => {
                  userArray = [...userArray, ...v[val]];
                });
                return userArray.find((b) => {
                  return (
                    (getV2ValueWP(param1, b, subjectUser) || "").toString() ===
                    (getV2ValueWP(param2, b, subjectUser) || "").toString()
                  );
                });
              }
              return (
                (getV2ValueWP(param1, v, subjectUser) || "").toString() ===
                (getV2ValueWP(param2, v, subjectUser) || "").toString()
              );
            });
          case "!==":
            return array?.find(
              (v: any) =>
                (getV2ValueWP(param1, v, subjectUser) || "").toString() ===
                (getV2ValueWP(param2, v, subjectUser) || "").toString(),
            );
          case "userIn":
            return array.filter((v: any) => {
              let identifierMatch = true;
              if (renderOptions.parentValue) {
                let userArray: any[] = [];

                if (data.identifier && v._id) {
                  identifierMatch = data.identifier === v._id;
                }

                parentValues.forEach((val) => {
                  if (v[val]) {
                    userArray = [...userArray, ...v[val]];
                  }
                });

                return userArray?.find((b) => {
                  return matchTagsAndUser(b) && identifierMatch;
                });
              }
              return matchTagsAndUser(v) && identifierMatch;
            });
          case "filter ===":
            const ret = array.filter((v: any) => {
              const val1 = getV2ValueWP(param1, v, subjectUser);

              const val2 = getV2ValueWP(param2, v, subjectUser);

              // Check if val1 is an empty string and treat it as false
              const val1IsEmpty = val1 === "";

              return !val1IsEmpty
                ? tryParseJSON(val1) === tryParseJSON(val2)
                : tryParseJSON("false") === tryParseJSON(val2);
            });
            return ret;

          default:
            return [];
        }
      } else {
        return array;
      }
    }
    return [];
  }, [data, renderOptions.expression, renderOptions.value, renderOptions.parentValue, matchTagsAndUser, subjectUser]);

  return (
    <>
      {data && renderOptions && (
        <>
          {_.isArray(value()) &&
            value().length > 0 &&
            value().map((v: any, i: number) => {
              return renderOptions.components.map((c, j) => {
                return (
                  <ComponentFinder
                    key={"finder_" + i + j}
                    data={v}
                    renderOptions={c}
                    componentKey={c.componentKey}
                    isInPast={past}
                  />
                );
              });
            })}
          {!_.isArray(value()) &&
            renderOptions.components.map((c, i) => {
              return (
                <ComponentFinder
                  key={"finder_" + c.componentKey + i}
                  data={value()}
                  renderOptions={c}
                  componentKey={c.componentKey}
                  isInPast={past}
                />
              );
            })}
        </>
      )}
    </>
  );
};
